import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  imports: [FormsModule, RouterLink],
  templateUrl: './forgot-password.html',
})
export class ForgotPassword {
  private auth = inject(AuthService);

  protected readonly email = signal('');
  protected readonly submitting = signal(false);
  protected readonly sent = signal(false);
  protected readonly error = signal<string | null>(null);

  protected async submit(): Promise<void> {
    if (this.submitting()) return;
    this.error.set(null);
    const email = this.email().trim();
    if (!email) {
      this.error.set('Enter your email address.');
      return;
    }
    this.submitting.set(true);
    const { error } = await this.auth.requestPasswordReset(email);
    this.submitting.set(false);
    if (error) {
      this.error.set(error);
      return;
    }
    this.sent.set(true);
  }
}